import { segment } from '@actions/analytics';
import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { GTP_TEST_SERIES_TYPE_MAP } from '@constants/index';
import { getPlusSubscriptionInfoLatest } from '@selectors/subscription';
import { emptyObject } from '@constants/empty';

const useTestSegmentAnalytics = (testType, isSpecial) => {
  const router = useRouter();
  const { query } = router;
  const { goalUID, goalSlug } = query;

  const {
    subscription = emptyObject,
    expired_at,
    time_remaining
  } = useSelectorWithShallowEqual(getPlusSubscriptionInfoLatest(goalUID)) ??
  emptyObject;

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      subscription_end_date: expired_at,
      subscription_duration: subscription.duration,
      is_subscription_active: time_remaining > 0,
      goal_name: goalSlug,
      goal_uid: goalUID,
      test_section:
        testType === GTP_TEST_SERIES_TYPE_MAP.COMING_SOON
          ? 'Upcoming'
          : 'Ongoing',
      test_eligibility_type: isSpecial ? 'Free Test' : 'Plus Test',
      ...additionalProps
    });
  };
};

export default useTestSegmentAnalytics;
